import { createSlice } from '@reduxjs/toolkit'

// general imports
import {
  ApiRequestDataType,
  ApiRequestStatus,
  StoredErrorResponseType,
} from '../../../types/api/api.types'
import { getSubscriptionTotalIncomeThunk } from '../thunks/income.thunk'
import { SubscriptionIncomeResponseType } from '../../../types/income.type'

export type SubscriptionTotalIncomeState = {
  // eslint-disable-next-line
  requestResponse: ApiRequestDataType<any>
  subscriptionTotalIncome: number
}

export const initialState: SubscriptionTotalIncomeState = {
  requestResponse: {
    status: ApiRequestStatus.IDLE,
    data: null,
  },
  subscriptionTotalIncome: 0,
}

const SubscriptionTotalIncomeSlice = createSlice({
  name: 'SubscriptionTotalIncomeSlice',
  initialState: initialState,
  reducers: {
    resetSubscriptionTotalIncomeState: (state) => {
      ;(state.requestResponse.status = ApiRequestStatus.IDLE), (state.requestResponse.data = null)
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSubscriptionTotalIncomeThunk.pending, (state) => {
        state.requestResponse.status = ApiRequestStatus.PENDING
        state.requestResponse.data = null
        state.requestResponse.error = {} as StoredErrorResponseType
      })
      .addCase(getSubscriptionTotalIncomeThunk.fulfilled, (state, action) => {
        state.requestResponse.status = ApiRequestStatus.FULFILLED
        if (
          action.payload &&
          typeof action.payload === 'object' &&
          'Subscription_income' in action.payload
        ) {
          state.subscriptionTotalIncome = (
            action.payload as SubscriptionIncomeResponseType
          ).Subscription_income
        } else {
          state.subscriptionTotalIncome = 0
        }
      })
      .addCase(getSubscriptionTotalIncomeThunk.rejected, (state, action) => {
        state.requestResponse.status = ApiRequestStatus.REJECTED
        state.requestResponse.error = action.payload as StoredErrorResponseType
      })
  },
})

export const { resetSubscriptionTotalIncomeState } = SubscriptionTotalIncomeSlice.actions
export default SubscriptionTotalIncomeSlice.reducer
